import { actionTypes } from './constants';
import { IFutureAnthemsAction, IPlayerTag, ITerms } from './types';

type Action<T extends actionTypes, P> = {
    type: T;
    payload: P;
};

export const userSetUrlTemplatesAction = (urlTemplates: string[]): Action<actionTypes.SET_URL_TEMPLATES, string[]> => ({
    type: actionTypes.SET_URL_TEMPLATES,
    payload: urlTemplates
});

export const userSetJustRegistered = (justRegistered: boolean): Action<actionTypes.SET_JUST_REGISTERED, boolean> => ({
    type: actionTypes.SET_JUST_REGISTERED,
    payload: justRegistered
});

export const userSetTerms = (terms: ITerms): Action<actionTypes.SET_TERMS, ITerms> => ({
    type: actionTypes.SET_TERMS,
    payload: terms
});

export const setAllPlayerTags = (allPlayerTags: Record<string, IPlayerTag>): Action<
    actionTypes.SET_ALL_PLAYER_TAGS,
    Record<string, IPlayerTag>
> => ({
    type: actionTypes.SET_ALL_PLAYER_TAGS,
    payload: allPlayerTags
});

export const removePlayerTag = (playerTag: string): Action<
    actionTypes.REMOVE_PLAYER_TAG,
    string
> => ({
    type: actionTypes.REMOVE_PLAYER_TAG,
    payload: playerTag
});

export const setUpdatedBalances = (updatedBalances: []): Action<actionTypes.SET_UPDATED_BALANCES, []> => ({
    type: actionTypes.SET_UPDATED_BALANCES,
    payload: updatedBalances
});

export const setJumioStatus = (status: string): Action<actionTypes.SET_JUMIO_STATUS, string> => ({
    type: actionTypes.SET_JUMIO_STATUS,
    payload: status
});

export const setJumioStep = (step: string): Action<actionTypes.SET_JUMIO_STEP, string> => ({
    type: actionTypes.SET_JUMIO_STEP,
    payload: step
});

export const setActionAfterLogin = (actionAfterLogin: () => void): Action<actionTypes.SET_ACTION_AFTER_LOGIN, () => void> => ({
    type: actionTypes.SET_ACTION_AFTER_LOGIN,
    payload: actionAfterLogin
});

export const setFutureAnthemsGames = (payload: IFutureAnthemsAction): Action<
    actionTypes.SET_FUTURE_ANTHEMS_GAMES,
    IFutureAnthemsAction
> => ({
    type: actionTypes.SET_FUTURE_ANTHEMS_GAMES,
    payload
});

export const setOccupation = (payload: boolean): Action<actionTypes.SET_OCCUPATION, boolean> => ({
    type: actionTypes.SET_OCCUPATION,
    payload
});

export const setIsShowOccupationPopup = (payload: boolean): Action<actionTypes.SET_IS_SHOW_OCCUPATION_POPUP, boolean> => ({
    type: actionTypes.SET_IS_SHOW_OCCUPATION_POPUP,
    payload
});
